var React = require('react');

function FilterSmall (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("path",{"d":"M15,4H8.06A2.12,2.12,0,0,0,3.94,4H1V5H3.94A2.12,2.12,0,0,0,8.06,5H15ZM6,5.62A1.12,1.12,0,1,1,7.12,4.5,1.12,1.12,0,0,1,6,5.62Z","key":1}),React.createElement("path",{"d":"M15,10H12.06a2.12,2.12,0,0,0-4.12,0H1v1H7.94a2.12,2.12,0,0,0,4.12,0H15Zm-5,1.62a1.12,1.12,0,1,1,1.12-1.12A1.12,1.12,0,0,1,10,11.62Z","key":2})]);
}

FilterSmall.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15"};

module.exports = FilterSmall;

FilterSmall.default = FilterSmall;
